import { Link } from 'react-router-dom';

const vyasaProducts = [
  { icon: '🏛️', name: 'VAHANA', tag: 'Tokenized Securities Issuance', desc: 'Full issuance workflow for Reg D, A+, CF, and Reg S. Term sheet to token deployment compressed from 4–6 weeks to 24 hours through AI agent orchestration.' },
  { icon: '🏗️', name: 'CapSeriesX', tag: 'Real Estate · Series LLC Capital', desc: 'Series LLC asset management for income-producing real estate. Fractional ownership, digital transfer controls, and automated investor distributions.' },
  { icon: '🏢', name: 'DevRaise', tag: 'Real Estate Development Capital', desc: 'Capital raising infrastructure for real estate development projects through tokenized securities. Turns months of manual capital formation into days.' },
  { icon: '🤖', name: 'ONIRAS', tag: 'AI Orchestration · 8 Domain SLMs', desc: 'Eight domain-specific AI models for legal, tax, compliance, document generation, and AML — answering regulatory Q&A and drafting SAR narratives autonomously.' },
  { icon: '📊', name: 'K-1 Tax Engine', tag: 'Native Tax Reporting · Industry First', desc: 'The only tokenization platform with native K-1 generation. 704(b)/(c) allocations, PFIC reporting, and UBTI handled automatically.' },
  { icon: '🔍', name: 'PURON · ORIGIN', tag: 'KYC / AML · Investor Passport', desc: 'Automated KYC/AML workflow plus a portable Soulbound Token investor passport — verified investors never repeat KYC across multiple offerings.' },
  { icon: '📈', name: 'ORVAL · ORAXIL', tag: 'Cap Table · P2P Secondary Market', desc: 'Real-time on-chain cap table management plus a compliant peer-to-peer secondary market for token holders after the lock-in period.' },
  { icon: '🌐', name: 'White-Label Engine', tag: 'Enterprise Licensing · Partner Revenue', desc: 'Any qualified marketplace operator can run their own branded VYASA instance — creating a recurring enterprise licensing revenue stream.' },
];

const vyasaStats = [
  { value: '21', label: 'Named Product Brands' },
  { value: '9',  label: 'Stakeholder Portal Types' },
  { value: '8',  label: 'AI Domain SLMs' },
  { value: '5',  label: 'SEC Regulations Covered' },
];

export default function VyasaSection() {
  return (
    <section id="vyasa" className="vyasa-section">
      <div className="vyasa-shell">
        <div className="vyasa-top">
          <div>
            <div className="vyasa-label-badge">🔒 Enterprise Platform · Operated by DeFi Assets LLC</div>
            <h2 className="vyasa-title">
              VYASA: <span>The Capital Markets Operating System</span>
            </h2>
            <div className="vyasa-text">
              <p>
                VYASA is the first full-stack, AI-powered enterprise platform for tokenized securities — covering every SEC exemption, every asset class, and every professional participant from issuance to tax reporting, KYC to cap table management.
              </p>
              <p>
                <strong>Positioned as the middle-market alternative to Securitize and tZERO</strong> — serving companies raising $250K–$10M that institutional platforms cannot profitably serve. No other platform combines tokenized issuance, native K-1 tax engine, and 8 AI compliance models under one SOC 2 umbrella.
              </p>
            </div>
            <div className="vyasa-cta">
              <Link to="/portfolio" className="btn-gold">Explore VYASA →</Link>
              <Link to="/about" className="btn-ghost-vyasa">View Architecture</Link>
            </div>
          </div>

          <div className="vyasa-stats">
            {vyasaStats.map((s) => (
              <div key={s.label} className="vyasa-stat">
                <span className="vyasa-stat-value">{s.value}</span>
                <span className="vyasa-stat-label">{s.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="vyasa-divider" />
        <div className="vyasa-brands-label">Our Brands — VYASA Product Ecosystem</div>

        <div className="vyasa-grid">
          {vyasaProducts.map((p) => (
            <div key={p.name} className="vyasa-card">
              <div className="oc-icon">{p.icon}</div>
              <div className="oc-name">{p.name}</div>
              <span className="oc-tag">{p.tag}</span>
              <p className="oc-text">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
